<template>
    <div>
        <div class="plain-card" v-if="true">
            <h5 @click.prevent="toggleFilters($event)" class="pointer">
                <i class="fa fa-caret-down pull-left active pen-pink"></i>
                {{ uLang('app.choose_filters') }}
            </h5>

            <div v-if="show_filters">
                <div class="col-md-10 col-xl-10 col-12">
                    <div class="row form-group">
                        <label class="col-md-2 col-sm-12 col-form-label">{{ uLang('app.name_filter') }}</label>
                        <div class="col-md-4 col-sm-12">
                            <div class="input-group">
                                <input type="text" class="form-control inline-input" v-model="filters.name"/>
                                <button
                                    v-if="filters['name'] !== null"
                                    @click="clearFilter('name')"
                                    class="btn btn-brand input-group-append"
                                >
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>
                        <label class="col-md-2 col-sm-12 col-form-label">{{ uLang('app.region_filter') }}</label>
                        <div class="col-md-4 col-sm-12">
                            <div class="input-group">
                                <select class="form-control inline-input custom-select" v-model="filters.region">
                                    <option v-for="region in regions" :value="region.id">{{ region.value }}</option>
                                </select>
                                <button
                                    v-if="filters['region'] !== null"
                                    @click="clearFilter('region')"
                                    class="btn btn-brand input-group-append"
                                >
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="row form-group">
                        <label class="col-md-2 col-sm-12 col-form-label">{{ uLang('app.date_from_filter') }}</label>
                        <div class="col-md-4 col-sm-12">
                            <div class="input-group">
                                <vue-pikaday
                                    v-model="filters.date_from"
                                    placeholder="Van"
                                    class="form-control"
                                    autocomplete="off"
                                />
                                <button
                                    v-if="filters.date_from !== null"
                                    @click="clearFilter('date_from')"
                                    class="btn btn-brand input-group-append"
                                >
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>
                        <label class="col-md-2 col-sm-12 col-form-label">{{ uLang('app.date_to_filter') }}</label>
                        <div class="col-md-4 col-sm-12">
                            <div class="input-group">
                                <vue-pikaday
                                    v-model="filters.date_to"
                                    placeholder="Tot"
                                    class="form-control"
                                    autocomplete="off"
                                />
                                <button
                                    v-if="filters.date_to !== null"
                                    @click="clearFilter('date_to')"
                                    class="btn btn-brand input-group-append"
                                >
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row inline-form mt-3">
                        <button class="btn btn-brand pull-right" @click="filteredData">
                            {{ uLang('app.filter') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="plain-card">
            <h2>{{ uLang('app.coaches') }}</h2>
            <table>
                <thead>
                    <tr>
                        <th>
                            <span class="pull-left">
                                {{ uLang('app.name') }}
                            </span>
                        </th>
                        <th>
                            <span class="pull-left">
                                {{ uLang('app.region') }}
                            </span>
                        </th>
                        <th>
                            <span class="pull-left">
                                {{ uLang('app.average_grade') }}
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="coach in coaches">
                        <tr @click="setSelectedCoach(coach.relation.id)" class="coach-feedback-row">
                            <td width="33%">
                                <span @click.stop.prevent class="pull-left">
                                    <link-if-permissions
                                        permissions="view-relations"
                                        :to="{ name: 'admin.relations.view', params: { id: coach.relation ? coach.relation.id : null }}"
                                    >
                                        {{ coach.relation ? coach.relation.full_name : '' }}
                                    </link-if-permissions>
                                </span>

                            </td>
                            <td width="33%">
                                <span class="pull-left">
                                    {{ coach.relation?.region?.value || '' }}
                                </span>
                            </td>
                            <td width="33%">
                                <span class="pull-left text-brand">
                                    {{ calculateAverage(coach.relation_id) }}
                                </span>
                            </td>
                        </tr>
                    </template>
                    <tr>
                        <td class="average-total-text" colspan="2">
                            <b>{{ uLang('app.average_total') }}: </b>
                        </td>
                        <td>
                            <b class="pull-left">{{ total_average }}</b>
                        </td>
                    </tr>
                </tbody>
            </table>
            <rea-loader :loading="loading"></rea-loader>
        </div>
    </div>
</template>

<script>
    import { ReaLoader } from "~/components/helpers";
    import TrajectoryManagerSelect from "../../../Form/elements/trajectory-manager-select";
    import { ToggleFiltersMixin } from '~/mixins/management-info'

    export default {
        name: "CoachFeedback",
        components: {
            TrajectoryManagerSelect,
            ReaLoader,
        },
        mixins: [ToggleFiltersMixin],
        data() {
            return {
                coaches: [],
                coach_grades: [],
                regions: {},
                total_average: 0,
                filters: {
                    name: null,
                    region: null,
                    date_from: null,
                    date_to: null
                },
                loading: true,
            }
        },
        methods: {
            setSelectedCoach(id) {
                this.$router.push({ name: 'admin.reports.selected-coach-feedback', params: { coachId: id } })
            },
            fetchData() {
                this.loading = true;
                this.clearCoachData();
                window.axios.get(route('coaches.all')).then(({ data }) => {
                    for (let i = 0; i < data.length; i++) {
                        if (!this.coaches.some(obj => obj.relation_id === data[i].relation_id)) {
                            this.coaches.push(data[i])
                            this.coach_grades.push({ relation_id: data[i].relation_id, grades: [data[i].coach_rating] })
                        } else {
                            let index = this.coach_grades.findIndex(obj => obj.relation_id === data[i].relation_id)
                            this.coach_grades[index].grades.push(data[i].coach_rating)
                        }
                    }

                    this.loading = false;
                });
            },
            clearCoachData() {
                this.coaches = [];
                this.coach_grades = [];
                this.total_average = 0
            },
            calculateAverage(coach_id) {
                let grades = this.coach_grades.find(obj => obj.relation_id === coach_id).grades
                let total = 0;
                for (let i = 0; i < grades.length; i++) {
                    total += grades[i];
                }
                return Math.round(total / grades.length * 10) / 10;
            },
            filteredData() {
                this.loading = true;

                this.clearCoachData();
                let filters = this.getFilters()

                window.axios.get(route('coaches.filtered', { filters })).then(({ data }) => {
                    this.coaches = []
                    for (let i = 0; i < data.length; i++) {
                        if (!this.coaches.some(obj => obj.relation_id === data[i].relation_id)) {
                            this.coaches.push(data[i])
                            this.coach_grades.push({ relation_id: data[i].relation_id, grades: [data[i].coach_rating] })
                        } else {
                            let index = this.coach_grades.findIndex(obj => obj.relation_id === data[i].relation_id)
                            this.coach_grades[index].grades.push(data[i].coach_rating)
                        }
                    }

                    this.loading = false;
                })
            },
            getFilters() {
                return JSON.stringify({
                    'name': this.filters.name,
                    'region': this.filters.region,
                    'date_from': this.filters.date_from,
                    'date_to': this.filters.date_to
                })
            },
            getTotalAverage() {
                let averages = []
                for (let i = 0; i < this.coach_grades.length; i++) {
                    averages.push(this.calculateAverage(this.coach_grades[i].relation_id))
                }

                let total = 0;
                for (let i = 0; i < averages.length; i++) {
                    total += averages[i];
                }

                this.total_average = Math.round((total / averages.length) * 10) / 10;
            },
            getRegions() {
                window.axios.get(route('region.all')).then(({ data }) => {
                    this.regions = data
                })
            },
            clearFilter(value) {
                this.filters[value] = null
            },
        },
        mounted() {
            this.fetchData()
            this.getRegions()
        },
        watch: {
            coaches() {
                this.getTotalAverage()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .fa-caret-down {
        transition: transform .3s ease;

        &.active {
            -webkit-transform: rotate(-180deg);
            -moz-transform: rotate(-180deg);
            -o-transform: rotate(-180deg);
            -ms-transform: rotate(-180deg);
            transform: rotate(-180deg);
        }
    }

    .plain-card {
        background-color: white;
        padding: 20px;
        position: relative;
        box-shadow: 3px 1px 5px #ccc;

        &:not(:first-child) {
            margin-top: 30px;
        }

        h2 {
            margin-bottom: 20px;
        }

        table {
            width: 100%;
            td, th {
                border: 1px solid black;
                padding: 6px;
                text-align: right;
            }

            tbody {
                th {
                    min-width: 190px;
                }
            }
        }
    }
    .coach-feedback-row {
        cursor: pointer;
        &:hover {
            background-color: #efefef;
        }
    }
    .average-total-text {
        text-align: right;
    }
</style>
